import type { ReactNode } from 'react';

function formatInline(text: string): ReactNode {
  const parts: ReactNode[] = [];
  let remaining = text;
  let key = 0;

  while (remaining.length > 0) {
    const boldMatch = remaining.match(/\*\*(.+?)\*\*/);
    const linkMatch = remaining.match(/\[(.+?)\]\((.+?)\)/);

    if (!boldMatch && !linkMatch) {
      parts.push(remaining);
      break;
    }

    const boldIndex = boldMatch ? remaining.indexOf(boldMatch[0]) : Infinity;
    const linkIndex = linkMatch ? remaining.indexOf(linkMatch[0]) : Infinity;

    if (boldIndex <= linkIndex && boldMatch) {
      if (boldIndex > 0) {
        parts.push(remaining.slice(0, boldIndex));
      }
      parts.push(<strong key={key++}>{boldMatch[1]}</strong>);
      remaining = remaining.slice(boldIndex + boldMatch[0].length);
      continue;
    }

    if (linkMatch) {
      if (linkIndex > 0) {
        parts.push(remaining.slice(0, linkIndex));
      }
      parts.push(
        <a key={key++} href={linkMatch[2]}>
          {linkMatch[1]}
        </a>,
      );
      remaining = remaining.slice(linkIndex + linkMatch[0].length);
    }
  }

  return parts.length === 1 ? parts[0] : <>{parts}</>;
}

export function renderMarketingMarkdown(content: string): ReactNode[] {
  const blocks = content.split('\n\n');

  return blocks.map((block, index) => {
    const trimmed = block.trim();
    if (!trimmed) {
      return null;
    }

    if (trimmed.startsWith('### ')) {
      return <h3 key={index}>{formatInline(trimmed.slice(4))}</h3>;
    }

    if (trimmed.startsWith('## ')) {
      return <h2 key={index}>{formatInline(trimmed.slice(3))}</h2>;
    }

    if (trimmed.startsWith('- ')) {
      const items = trimmed.split('\n').filter((line) => line.startsWith('- '));
      return (
        <ul key={index}>
          {items.map((item, itemIndex) => (
            <li key={itemIndex}>{formatInline(item.slice(2))}</li>
          ))}
        </ul>
      );
    }

    return <p key={index}>{formatInline(trimmed)}</p>;
  });
}
